import { Box, Flex, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';

interface Props {
  title: string;
  subtitle: string;
  subtitle2: string;
  detailImageUrl: string;
  primaryColor: string;
}

const ServiceProductIntroCard: FC<Props> = ({
  title,
  subtitle,
  subtitle2,
  detailImageUrl,
  primaryColor,
}) => {
  const textShadow = '0px 4px 11px rgba(0, 0, 0, 0.3)';

  return (
    <AppCard
      pos="relative"
      bgColor={primaryColor || Color.Primary500}
      overflow="hidden"
      minH="200px"
    >
      <Box
        position="absolute"
        left="0"
        top="0"
        w="100%"
        h="100%"
        bgImage={`url(${detailImageUrl})`}
        bgSize="cover"
        bgPosition="center"
        bgRepeat="no-repeat"
      />
      <Box
        position="absolute"
        left="0"
        top="0"
        w="100%"
        h="100%"
        bgGradient="linear(to-t, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0) 80%)"
      />
      <Flex
        zIndex={5}
        position="absolute"
        bottom="0"
        left="0"
        w="100%"
        flexDir="column"
        justifyContent="flex-end"
        pb="20px"
        px="25px"
      >
        <Text
          textShadow={textShadow}
          color={Color.OnPrimary}
          fontWeight={800}
          fontSize="28px"
          mb="8px"
          maxW="60%"
        >
          {title}
        </Text>
        {subtitle && (
          <Text
            textShadow={textShadow}
            color={Color.OnPrimary}
            fontWeight={700}
            fontSize="22px"
            mb="5px"
          >
            {subtitle}
          </Text>
        )}
        {subtitle2 && (
          <Text
            textShadow={textShadow}
            color={Color.OnPrimary}
            fontWeight={600}
            fontSize={FontSize.sm}
          >
            {subtitle2}
          </Text>
        )}
      </Flex>
    </AppCard>
  );
};

export default ServiceProductIntroCard;
